import React from 'react';

const VisibleIcon = (props: any) => {
  return (
    <svg height="16" width="16" fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1.40039 7.99995C1.40039 7.99995 3.80039 3.19995 8.00039 3.19995C12.2004 3.19995 14.6004 7.99995 14.6004 7.99995C14.6004 7.99995 12.2004 12.8 8.00039 12.8C3.80039 12.8 1.40039 7.99995 1.40039 7.99995Z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
      />
      <path
        d="M8.00117 9.79995C8.99528 9.79995 9.80117 8.99406 9.80117 7.99995C9.80117 7.00584 8.99528 6.19995 8.00117 6.19995C7.00706 6.19995 6.20117 7.00584 6.20117 7.99995C6.20117 8.99406 7.00706 9.79995 8.00117 9.79995Z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
      />
    </svg>
  );
};

export default VisibleIcon;
